import Link from "next/link";
import { Fragment, ReactElement } from "react";

type Props = {
  /**
   * Where the card routes to, as resolved by `useCallCardLink`. A call with no reachable
   * destination has none, and renders unwrapped rather than as a dead link.
   */
  link: string | null;
  children?: ReactElement;
};

export default function CallCardLink({ link, children }: Props) {
  if (!link) return <Fragment>{children}</Fragment>;

  return (
    <Link data-testid={link} href={link} shallow scroll={false}>
      {children}
    </Link>
  );
}
